export default __webpack_public_path__ + "static/the-propane-home-bg-en-b962bbd34a3dda6f74adebfcfdc3da47.jpg";